// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6b32e746","455":"2398486b","977":"4affb0e2"}[chunkId] + ".chunk.js";
};